import { Middleware } from 'redux';
import IPagination from '../../types/IPagination';
import { produce } from 'immer';

const PAGE = 'current-page';
const NEXT_PAGE = 'next-page';
const PREV_PAGE = 'previous-page';
const COUNT = 'total-count';
const PAGE_COUNT = 'page-count';

const paginationMiddleware: Middleware = () => (next) => (originalAction) => {
    const pagination: Partial<IPagination> = {};
    const headers = originalAction?.payload?.headers;

    if (headers) {
        if (headers[PAGE]) {
            pagination.page = parseInt(headers[PAGE], 10);
        }
        if (headers[NEXT_PAGE]) {
            pagination.nextPage = parseInt(headers[NEXT_PAGE], 10);
        }
        if (headers[PREV_PAGE]) {
            pagination.prevPage = parseInt(headers[PREV_PAGE], 10);
        }
        if (headers[COUNT]) {
            pagination.totalCount = parseInt(headers[COUNT], 10);
        }
        if (headers[PAGE_COUNT]) {
            pagination.pageCount = parseInt(headers[PAGE_COUNT], 10);
        }
    }

    if (Object.keys(pagination).length > 0) {
        const newAction = produce(originalAction, (draft) => {
            draft.payload = { ...draft.payload, pagination };
        });
        return next(newAction as any);
    }

    return next(originalAction);
};

export default paginationMiddleware;
